import { ModalStoreActionKind, ModalStoreReducer, } from './ModalReducer';
import { useSyncExternalStore } from 'react';
let state = { modals: new Map(), queue: new Set() };
const listeners = new Set();
export const modalStoreApi = {
    queue(id) {
        dispatch({
            type: ModalStoreActionKind.QUEUE,
            id,
        });
    },
    dequeue(id) {
        dispatch({
            type: ModalStoreActionKind.DEQUEUE,
            id,
        });
    },
    clear() {
        dispatch({
            type: ModalStoreActionKind.CLEAR,
        });
    },
};
const modalStore = {
    subscribe(listener) {
        listeners.add(listener);
        return () => {
            listeners.delete(listener);
        };
    },
    getSnapshot() {
        return state;
    },
};
function emit() {
    for (const listener of listeners) {
        listener();
    }
}
function dispatch(action) {
    state = ModalStoreReducer(state, action);
    emit();
}
export const useModalStore = () => useSyncExternalStore(modalStore.subscribe, modalStore.getSnapshot);
//# sourceMappingURL=ModalStore.js.map